import styled from 'styled-components';

export const ChooseGameBox = styled.div`
`;

export const GamesListBox = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

export const GameBox = styled.div`
    width: 50%;
    display: flex;
    align-items: center;
    & button {
        margin: 5px;
        padding: 40px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    & span {
        font-size: 18px;
    }
`;

export const CurrentGameBox = styled.div`
`;